export const Types = {
    GET_BREAKDOWN_REASONGROUP_LIST: "GET_BREAKDOWN_REASONGROUP_LIST",
    SET_BREAKDOWN_REASONGROUP_LIST: "SET_BREAKDOWN_REASONGROUP_LIST",

    GET_BREAKDOWN_EFFECT_LIST: "GET_BREAKDOWN_EFFECT_LIST",
    SET_BREAKDOWN_EFFECT_LIST: "SET_BREAKDOWN_EFFECT_LIST",

    GET_AREA_LIST_IN_BREAKDOWN: "GET_AREA_LIST_IN_BREAKDOWN",
    SET_AREA_LIST_IN_BREAKDOWN: "SET_AREA_LIST_IN_BREAKDOWN",

    GET_BREAKDOWN_EQUIPMENT_GET_MAIN_LIST_BY_AREA_ID: "GET_BREAKDOWN_EQUIPMENT_GET_MAIN_LIST_BY_AREA_ID",
    SET_BREAKDOWN_EQUIPMENT_GET_MAIN_LIST_BY_AREA_ID: "SET_BREAKDOWN_EQUIPMENT_GET_MAIN_LIST_BY_AREA_ID",

    GET_EQUIPMENT_GET_SUB_LIST_BY_ID: "GET_EQUIPMENT_GET_SUB_LIST_BY_ID",
    SET_EQUIPMENT_GET_SUB_LIST_BY_ID: "SET_EQUIPMENT_GET_SUB_LIST_BY_ID",

    GET_POOL_LIST_IN_BREAKDOWN: "GET_POOL_LIST_IN_BREAKDOWN",
    SET_POOL_LIST_IN_BREAKDOWN: "SET_POOL_LIST_IN_BREAKDOWN",

    GET_BREAKDOWN_REASON_PLACE_GET_LIST_BY_GROUP_ID: "GET_BREAKDOWN_REASON_PLACE_GET_LIST_BY_GROUP_ID",
    SET_BREAKDOWN_REASON_PLACE_GET_LIST_BY_GROUP_ID: "SET_BREAKDOWN_REASON_PLACE_GET_LIST_BY_GROUP_ID",

    POST_UNPLANNED_MAINTENANCE_CREATE_WITH_FILE: "POST_UNPLANNED_MAINTENANCE_CREATE_WITH_FILE",
    SET_UNPLANNED_MAINTENANCE_CREATE_WITH_FILE: "SET_UNPLANNED_MAINTENANCE_CREATE_WITH_FILE",

    GET_EQUIPMENT_GET_BY_BARCODE_CONTEXT: "GET_EQUIPMENT_GET_BY_BARCODE_CONTEXT",
    SET_EQUIPMENT_GET_BY_BARCODE_CONTEXT: "SET_EQUIPMENT_GET_BY_BARCODE_CONTEXT",
};

export const getBreakdownReasonGroupList = () => ({
    type: Types.GET_BREAKDOWN_REASONGROUP_LIST,
});

export const setBreakdownReasonGroupList = (payload) => ({
    type: Types.SET_BREAKDOWN_REASONGROUP_LIST,
    payload,
});

export const getBreakdownEffectList = () => ({
    type: Types.GET_BREAKDOWN_EFFECT_LIST,
});

export const setBreakdownEffectList = (payload) => ({
    type: Types.SET_BREAKDOWN_EFFECT_LIST,
    payload,
});

export const getAreaList = () => ({
    type: Types.GET_AREA_LIST_IN_BREAKDOWN,
});

export const setAreaList = (payload) => ({
    type: Types.SET_AREA_LIST_IN_BREAKDOWN,
    payload,
});

export const getEquipmentGetMainListByAreaID = (payload) => ({
    type: Types.GET_BREAKDOWN_EQUIPMENT_GET_MAIN_LIST_BY_AREA_ID,
    payload,
});

export const setEquipmentGetMainListByAreaID = (payload) => ({
    type: Types.SET_BREAKDOWN_EQUIPMENT_GET_MAIN_LIST_BY_AREA_ID,
    payload,
});

export const getEquipmentGetSubListById = (payload) => ({
    type: Types.GET_EQUIPMENT_GET_SUB_LIST_BY_ID,
    payload,
});

export const setEquipmentGetSubListById = (payload) => ({
    type: Types.SET_EQUIPMENT_GET_SUB_LIST_BY_ID,
    payload,
});

export const getPoolList = () => ({
    type: Types.GET_POOL_LIST_IN_BREAKDOWN,
});

export const setPoolList = (payload) => ({
    type: Types.SET_POOL_LIST_IN_BREAKDOWN,
    payload,
});

export const getBreakdownReasonPlaceGetListByGroupId = (payload) => ({
    type: Types.GET_BREAKDOWN_REASON_PLACE_GET_LIST_BY_GROUP_ID,
    payload,
});

export const setBreakdownReasonPlaceGetListByGroupId = (payload) => ({
    type: Types.SET_BREAKDOWN_REASON_PLACE_GET_LIST_BY_GROUP_ID,
    payload,
});

export const postUnplannedMaintenanceCreateWithFile = (payload) => ({
    type: Types.POST_UNPLANNED_MAINTENANCE_CREATE_WITH_FILE,
    payload,
});

export const setUnplannedMaintenanceCreateWithFile = (payload) => ({
    type: Types.SET_UNPLANNED_MAINTENANCE_CREATE_WITH_FILE,
    payload,
});

export const getEquipmentGetByBarcodeContext = (payload) => ({
    type: Types.GET_EQUIPMENT_GET_BY_BARCODE_CONTEXT,
    payload,
});

export const setEquipmentGetByBarcodeContext = (payload) => ({
    type: Types.SET_EQUIPMENT_GET_BY_BARCODE_CONTEXT,
    payload,
});
